import React from 'react';
import PropTypes from 'prop-types';
import KpiTable from '../../../commons/KpiTable';

const PartnerStudentVariationTable = (props) => (
  <KpiTable
    title="Growth of students studying"
    description="The number represents the percentage of students that studied in the month period compared to the previous month."
    loading={props.loading}
    values={props.values}
    currentHigherIsBetter={false}
    onSelect={props.onSelect}
    formatter={props.formatter}
    feedbackColorRender={props.feedbackColorRender}
    additionalColumns={[
      {
        label: 'Standard Deviation',
        path: 'currentStandardDeviation',
      },
      {
        label: 'Total of Registers',
        path: 'currentAmount',
      },
    ]}
  />
);

PartnerStudentVariationTable.propTypes = {
  onSelect: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  values: PropTypes.array.isRequired,
  formatter: PropTypes.func.isRequired,
  feedbackColorRender: PropTypes.func.isRequired,
};

export default PartnerStudentVariationTable;
